/* eslint no-bitwise: 0 */

// based on https://stackoverflow.com/a/21648508/910868
function hexToRgbA(hex: string, alpha: string | number): string {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = `0x${c.join('')}`;
    // $FlowFixMe
    return `rgba(${(+c >> 16) & 255},${(+c >> 8) & 255},${+c & 255},${alpha})`;
  }
  return hex;
}

export default hexToRgbA;
